'use strict';

(function () {
    'use strict';

    config.$inject = ['$stateProvider'];
    angular.module('damage').config(config);

    function config($stateProvider) {
        $stateProvider.state('damages', {
            url: '/damages',
            templateUrl: 'app/pages/damages/damages.html',
            controller: 'DamagesCtrl',
            controllerAs: 'vm'
        }).state('damage', {
            url: '/damage',
            templateUrl: 'app/pages/damages/damage.html',
            controller: 'DamageCtrl',
            controllerAs: 'vm',
            resolve: {
                params: function params() {
                    return {};
                }
            }
        });
    }
})();